<template>
	<div>
		
		<layout>

			<template v-slot:title> 
				CAMBIAR CONTRASEÑA
			</template>

			<template v-slot:subtitle> 
				CAMBIAR CONTRASEÑA
			</template>


			<template v-slot:content>

				<div id="cms-change-password">
					
					<v-container>

						<v-row class="mt-4">

							<v-col offset-md="4" md="4" offset-sm="3" sm="6" offset="1" cols="10">

						    <v-card class="mt-3" light elevation="5"> 

						  		<form @submit.prevent="changePassword()" class="pa-5" id="change-password-form">

						  			<div class="text-center mb-3">
						  				<v-icon size="100">mdi-lock</v-icon>
						  			</div>

										<v-text-field
											type="password"
						          label="Nueva contraseña"
						          filled
						          v-model="user.new_password"
						          required
						          minlength="8"
						          maxlength="20"
						        ></v-text-field> 

						        <v-text-field
						        	type="password"
						          label="Repetir contraseña"
						          filled
						          v-model="user.new_password2"
						          minlength="8"
						          maxlength="20"
						        ></v-text-field> 

						        <v-btn type="submit" dark large block>
								      Cambiar contraseña
								    </v-btn>

						  		</form>
						  	</v-card>

							</v-col>
						</v-row>

					</v-container>

				</div>

		  </template>

		</layout>

	</div>
</template>



<script>
	
	import Layout from './../../layout/Layout'
	import UserService from '@/shared/services/UserService'


	export default
	{

		data() {
			return {
				user: {
					new_password: null,
					new_password2: null
				}
			}
		},

		components: {
			Layout
		},

		methods: {

			async changePassword()
			{
				const resp = await UserService.changePassword(this.user)

				if(resp.data == 'OK')
				{
					SwalAlert('', 'Contraseña cambiada', 'success')

					this.user.new_password = null
					this.user.new_password2 = null
				}
				else
					SwalAlert('', 'Ha ocurrido un error, por favor intenta de nuevo', 'error')
			}

		}

	}

</script>